export default __webpack_public_path__ + "static/media/users.d4cb2850.svg";